import { Link } from 'react-router-dom';
import { Button, buttonVariants } from '@playcastdotio/Shadcn';
import { cn, isMobileDevice } from '../../utility/base';
import { download } from '../../utility/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindows } from '@fortawesome/free-brands-svg-icons';

export const WhyPlaycast = () => {
  return (
    <div className='bg-content text-content-text m-0 h-auto w-full p-0'>
      <div className='container mx-auto h-auto w-full py-20'>
        <section id='why-playcast' className='flex flex-col gap-y-4 px-4 text-center'>
          <h2 className='text-3xl font-bold'>Why Playcast?</h2>
          <p className='lg:px-56'>
            Play couch co-op games online with friends together from miles away. Stream games and invite viewers to play with you, then hand
            them the gamepad controls! Enjoy seamless, low-latency gameplay. Fully integrated with Open Broadcaster Software (OBS) for
            streamers.
            <br />
            <br />
            Click “download” to install the app and start hosting your own Playcast sessions.
          </p>
          <div className='flex w-full flex-col justify-center gap-2 px-4 md:flex-row'>
            {!isMobileDevice() && (
              <Button className='flex space-x-2 rounded-full' onClick={download}>
                <FontAwesomeIcon icon={faWindows} className='text-2xl' />
                <span>Download</span>
              </Button>
            )}
            <Link to='/faqs' className={cn(buttonVariants({ variant: 'outline' }), 'rounded-full')}>
              Learn More
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};
